export const supportFormPath = '/app/support-form'
export const supportFormSuccessPath = '/support-success'
